module.exports = __webpack_public_path__ + "static/media/AP_NES_Z2.68a6339b.png";